module.exports = __webpack_public_path__ + "img/img-96.4bd4f1d6.png";